// frontend/src/utils/permissions.js
//
// Delade behörighetshjälpare (speglar backendens permissions.py).
// Använd dessa istället för att upprepa `user?.is_admin || user?.is_clinic_admin`
// inline så att admin-regeln har en enda källa.

/** Global systemadministratör. */
export function isGlobalAdmin(user) {
  return Boolean(user && user.is_admin);
}

/** Global admin ELLER klinikadmin - får administrera sin egen klinik. */
export function isClinicLevelAdmin(user) {
  return Boolean(user && (user.is_admin || user.is_clinic_admin));
}
